export default "https://cdn-static.gokick.com/assets/e388117c7865c86e8cffce5bc7abacefcd582b49/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";